import { render, staticRenderFns } from "./radioItem.vue?vue&type=template&id=273dfa30&scoped=true"
import script from "./radioItem.vue?vue&type=script&lang=js"
export * from "./radioItem.vue?vue&type=script&lang=js"
import style0 from "./radioItem.vue?vue&type=style&index=0&id=273dfa30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273dfa30",
  null
  
)

export default component.exports